export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const HAS_LOGIN_PENDING = "HAS_LOGIN_PENDING";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const LOGOUT = "LOGOUT";

export const LOGIN_ATTEMPT_INIT = "LOGIN_ATTEMPT_INIT";
export const LOGIN_ATTEMPT_UPDATE = "LOGIN_ATTEMPT_UPDATE";
export const SET_LOGIN_ATTEMPT_BLOCKED = "SET_LOGIN_ATTEMPT_BLOCKED";

export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const TOGGLE_LOADING = "TOGGLE_LOADING";

export const SKELETON_LOADING = "SKELETON_LOADING";
